import { Building2, Car, Factory, Server, Cog, Box, type LucideIcon } from 'lucide-react';
import { AssetType } from '../types/emissions';

export interface AssetTypeBrand {
  Icon: LucideIcon;
  label: string;
  description: string;
  iconBg: string;
  iconColor: string;
  faIcon: string;
}

export const ASSET_TYPE_BRANDING: Record<AssetType, AssetTypeBrand> = {
  [AssetType.Facility]: {
    Icon: Building2,
    label: 'Facilities',
    description: 'Office, warehouse, retail, or other fixed sites',
    iconBg: 'tw:bg-blue-100',
    iconColor: 'tw:text-blue-600',
    faIcon: 'fal fa-building',
  },
  [AssetType.Vehicle]: {
    Icon: Car,
    label: 'Vehicles',
    description: 'Car, van, truck, or other motorised vehicles',
    iconBg: 'tw:bg-orange-100',
    iconColor: 'tw:text-orange-600',
    faIcon: 'fal fa-car',
  },
  [AssetType.ManufacturingFacility]: {
    Icon: Factory,
    label: 'Manufacturing Facilities',
    description: 'Factory, plant, or production facilities',
    iconBg: 'tw:bg-slate-100',
    iconColor: 'tw:text-slate-600',
    faIcon: 'fal fa-industry',
  },
  [AssetType.DataCentre]: {
    Icon: Server,
    label: 'Data Centres',
    description: 'Server facilities or co-locations',
    iconBg: 'tw:bg-purple-100',
    iconColor: 'tw:text-purple-600',
    faIcon: 'fal fa-server',
  },
  [AssetType.Equipment]: {
    Icon: Cog,
    label: 'Equipment',
    description: 'Standalone machinery or industrial equipment',
    iconBg: 'tw:bg-amber-100',
    iconColor: 'tw:text-amber-600',
    faIcon: 'fal fa-cog',
  },
  [AssetType.Other]: {
    Icon: Box,
    label: 'Others',
    description: 'Custom asset type',
    iconBg: 'tw:bg-gray-100',
    iconColor: 'tw:text-gray-500',
    faIcon: 'fal fa-box',
  },
};

export const getAssetTypeBrand = (type: string): AssetTypeBrand =>
  ASSET_TYPE_BRANDING[type as AssetType] ?? ASSET_TYPE_BRANDING[AssetType.Other];
